import type { Season } from '@proref/types';
import type { CreateSeasonInput, UpdateSeasonInput } from '@proref/schemas';
import { api, unwrap, type Envelope } from '../lib/api';

// The platform-wide season calendar behind the Leaderboard's Period control (every authenticated
// role reads the same list; only super_admin can mutate — mirrors services/sports.service.ts).
export async function listSeasons(): Promise<Season[]> {
  const res = await api.get<Envelope<Season[]>>('/seasons');
  return unwrap(res.data);
}

export async function createSeason(input: CreateSeasonInput): Promise<Season> {
  const res = await api.post<Envelope<Season>>('/seasons', input);
  return unwrap(res.data);
}

export async function updateSeason(id: string, input: UpdateSeasonInput): Promise<Season> {
  const res = await api.patch<Envelope<Season>>(`/seasons/${id}`, input);
  return unwrap(res.data);
}

// The API refuses (409 SEASON_OVERLAP) if the new range overlaps an existing season.
export async function deleteSeason(id: string): Promise<void> {
  await api.delete<Envelope<null>>(`/seasons/${id}`);
}
